import { Form } from "@circle-react-uikit/Form";
import { PASSWORD_REGEX } from "@circle-react/components/OnboardingPage/helpers/constants";
import { OtpSecurityBadge } from "@circle-react/components/OtpChallenge/components/OtpSecurityBadge";
import { PasswordStrengthIndicator } from "@circle-react/components/shared/PasswordField/PasswordStrengthIndicator";
import { PasswordVisibilityToggle } from "@circle-react/components/shared/PasswordField/PasswordVisibilityToggle";
import { usePasswordField } from "@circle-react/hooks/usePasswordField";

import { t } from "@/i18n-js/instance";
import { Button } from "@/react/components/SettingsApp/CompassCompat/Button";

import { PASSWORD_FIELD_NAME } from "./constants";

interface PasswordFieldsProps {
  isSubmitting: boolean;
}

export const PasswordFields = ({ isSubmitting }: PasswordFieldsProps) => {
  const {
    isPasswordVisible,
    setIsPasswordVisible,
    passwordValue,
    passwordFieldError,
    passwordStrength,
    handleBlur,
  } = usePasswordField({ fieldName: PASSWORD_FIELD_NAME });

  return (
    <div className="space-y-6">
      <Form.Item
        name={PASSWORD_FIELD_NAME}
        label={t("authentication_app.signup.form.password")}
        hideDescription
        hideBorder
        rules={{
          required: t(
            "authentication_app.signup.form.errors.password_required",
          ),
          pattern: {
            value: PASSWORD_REGEX,
            message: t(
              "authentication_app.signup.form.errors.password_invalid",
            ),
          },
        }}
      >
        <Form.Input
          type={isPasswordVisible && passwordValue ? "text" : "password"}
          autoComplete="new-password"
          onBlur={handleBlur}
          wrapperClassName="relative"
          suffix={
            <PasswordVisibilityToggle
              passwordValue={passwordValue}
              isPasswordVisible={isPasswordVisible}
              setIsPasswordVisible={setIsPasswordVisible}
            />
          }
        />
      </Form.Item>
      <PasswordStrengthIndicator
        passwordStrength={passwordStrength}
        passwordFieldError={passwordFieldError}
        passwordValue={passwordValue}
      />

      <Button
        variant="primary"
        type="submit"
        full
        extraLarge
        disabled={isSubmitting}
      >
        {t("otp_challenge_modal.continue")}
      </Button>

      <OtpSecurityBadge />
    </div>
  );
};

PasswordFields.displayName = "PasswordFields";
